/* eslint-disable css-modules/no-unused-class */
import React from 'react';

import PropTypes from 'prop-types';

import {
    Table,
    TableBody,
    TableHead,
    TableCell,
    TableRow,
    Typography,
} from 'wanderu-components';
import { localize } from 'wanderu-i18n';

import RoutesRow from './RoutesRow/RoutesRow';

import styles from './RoutesTable.scss';

const propTypes = {
    namespace: PropTypes.string,
    routeItems: PropTypes.arrayOf(PropTypes.shape({
        avgPrice: PropTypes.number,
        avgTime: PropTypes.number,
        dailyTrips: PropTypes.number,
        destination: PropTypes.string,
        url: PropTypes.string,
    })),
};

const defaultProps = {
    namespace: '',
    routeItems: [],
};

function RoutesTable(props) {
    const {
        i18nMoment,
        i18nMoney,
        t,
        namespace,
        routeItems = [],
    } = props;

    return (
        <>
            <Typography
                className={styles.headerRoutes}
                component="h2"
                id="routes-header-section"
                variant="h3"
            >
                {t(`${namespace}:routesTitle`)}
            </Typography>
            <Typography paragraph>
                {t(`${namespace}:routesDescription`)}
            </Typography>
            <Table className={styles.routeTable}>
                <TableHead>
                    <TableRow className={styles.tableHeader}>
                        <TableCell>
                            {t(`${namespace}:routesDestination`)}
                        </TableCell>
                        <TableCell>
                            {t(`${namespace}:routesTrips`)}
                        </TableCell>
                        <TableCell>
                            {t(`${namespace}:routesShortAvgTime`)}
                        </TableCell>
                        <TableCell>
                            {t(`${namespace}:routesShortAvgPrice`)}
                        </TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {routeItems.map((route) => (
                        <RoutesRow
                            avgPrice={route.avgPrice}
                            avgTime={t(route.avgTime)}
                            dailyTrips={route.dailyTrips}
                            destination={route.destination}
                            i18nMoment={i18nMoment}
                            i18nMoney={i18nMoney}
                            key={route.url}
                            t={t}
                            url={route.url}
                        />
                    ))}
                </TableBody>
            </Table>
        </>
    );
}

RoutesTable.propTypes = propTypes;
RoutesTable.defaultProps = defaultProps;

export {
    RoutesTable,
};
export default localize(RoutesTable);
